// @flow
import { ContactsActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    contact: {},
    listaContacts: [],
    loading: false,
    error: false,
    formSubmited: false
};

type ContactsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { contact?: {} | null, listaContacts?: [] | null, loading?: boolean, +value ?: boolean };

const Contacts = (state: State = INIT_STATE, action: ContactsAction): any => {
    // console.log(action);
    switch (action.type) {
        case ContactsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ContactsActionTypes.GET_CONTACT: {
                    return {
                        ...state,
                        contact: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ContactsActionTypes.LIST_CONTACTS: {
                    return {
                        ...state,
                        listaContacts: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ContactsActionTypes.ADD_CONTACT: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case ContactsActionTypes.UPDATE_CONTACT: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case ContactsActionTypes.DELETE_CONTACT: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case ContactsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ContactsActionTypes.GET_CONTACT: {
                    return {
                        ...state,
                        error: action.payload.error,
                        contact: {},
                        loading: false,
                    };
                }
                case ContactsActionTypes.LIST_CONTACTS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaContacts: [],
                        loading: false,
                    };
                }
                case ContactsActionTypes.ADD_CONTACT: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case ContactsActionTypes.UPDATE_CONTACT: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case ContactsActionTypes.DELETE_CONTACT: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case ContactsActionTypes.GET_CONTACT:
            return { ...state, error: false, loading: true };
        case ContactsActionTypes.LIST_CONTACTS:
            return { ...state, error: false, loading: true };
        case ContactsActionTypes.ADD_CONTACT:
            return { ...state, error: false, loading: true };
        case ContactsActionTypes.UPDATE_CONTACT:
            return { ...state, error: false, loading: true };
        case ContactsActionTypes.DELETE_CONTACT:
            return { ...state, error: false, loading: true };
        case ContactsActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                contact: {},
                listaContacts: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Contacts;
